import { IconProps } from './index';

const FilledVideoCamera = ({
    title,
    titleId,
    ...props
}: React.SVGProps<SVGSVGElement> & IconProps) => {
    return (
        <svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {title && <title id={titleId}>{title}</title>}
            <path
                d="M10.6665 0.666626C11.0345 0.666626 11.3332 0.965293 11.3332 1.33329V4.13329L14.8085 1.69996C14.9592 1.59463 15.1672 1.63129 15.2732 1.78263C15.3118 1.83863 15.3332 1.90529 15.3332 1.97329V10.0266C15.3332 10.2106 15.1838 10.36 14.9998 10.36C14.9312 10.36 14.8645 10.3386 14.8085 10.3L11.3332 7.86663V10.6666C11.3332 11.0346 11.0345 11.3333 10.6665 11.3333H1.33317C0.965171 11.3333 0.666504 11.0346 0.666504 10.6666V1.33329C0.666504 0.965293 0.965171 0.666626 1.33317 0.666626H10.6665Z"
                fill="#ED434B"
            />
        </svg>
    );
};

export default FilledVideoCamera;
